// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__1SFcS","content":"PrivacyPolicyPage_content__2saEE"};